module.exports = __webpack_public_path__ + "media/images/law_sara-b09c3bdcf70ae7e1723b43939ae168d6.svg";